export enum CohortSelectionModalEvent {
  LIVE_CLASS_SCHEDULE_SELECTION_CLOSE_WITH_SUCCESS_EVENT = 'live_class_schedule_selection_close_with_success_event',
  LIVE_CLASS_SCHEDULE_SELECTION_TRACKING_EVENT = 'live_class_schedule_selection_tracking_event',
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort-selection-modal/cohort-selection-modal-events.ts